/**
* @template File model declaration for storing asi capabilities, user type and packages
**/
export interface File {
  fileName: string;
  fileType: string;
  uploadedFiledata: Array<Array<string | number>>;
  isFileSubmitted: boolean;
  generation: string;
  packageGeneration: string;
  productGeneration: string;
  asiGeneration: string;
  asiproductGeneration: string;
  reviewApproved: boolean;
  supportedGenerations: Array<string>;
}
/**
* @const initialFile State model for storing  asi capabilities, user type and packages
**/
export const initialFile: File = {
  fileName: '',
  fileType: '',
  uploadedFiledata: [],
  isFileSubmitted: false,
  generation: '',
  packageGeneration: '',
  productGeneration: '',
  asiGeneration: '',
  asiproductGeneration: '',
  reviewApproved: false,
  supportedGenerations: []
};
